import { styled } from '@mui/material';
import clsx from 'clsx';
import { ComponentProps, memo } from 'react';

import { DataGridLevel2Context } from '../data-grid';

const Root = styled('footer')(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  position: 'sticky',
  fontWeight: 500,
  bottom: 0,
  willChange: 'transform',
  zIndex: 20,
  '& > *': { backgroundColor: 'inherit' },
}));

const contextValue = { variant: 'footer' } as const;

export const DataGridFoot = memo<ComponentProps<typeof Root>>(
  function DataGridFoot({ role, ...props }) {
    return (
      <DataGridLevel2Context.Provider value={contextValue}>
        <Root {...props} role={clsx('rowgroup', role)} />
      </DataGridLevel2Context.Provider>
    );
  },
);
